import User from '../user/class';

class Event {
  constructor(data) {
    this._id = data._id;
    this.workspace = data.workspace;
    this.action = data.action;
    this.createdAt = data.createdAt;
    this.status = data.status;

    this.initiator = new User(data.initiator);
    this.data = {
      ...data.data,
      project: data.data.project && {
        ...data.data.project,
        users: data.data.project.users.map((u) => new User(u)),
      },
    };
  }
}

export default Event;



// WEBPACK FOOTER //
// ./src/events/class.js